module.exports = __webpack_public_path__ + "static/media/cashewF.7c354894.png";